import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import {
  ExchangeAntimalwareItemStatus,
  getExchangeApplyToRule,
  getExchangeAntimalwareItemStatus,
  getExchangeRuleSenders,
} from '../../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { ExchangeAntimalwareExclusionFrontendFields } from '../GzExchangeAntimalwareExclusionsGridDataProvider';

// sort by column type
export function sortByColumn(
  item1: ExchangeAntimalwareExclusionFrontendFields,
  item2: ExchangeAntimalwareExclusionFrontendFields,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.NAME:
      return compareStrings(item1.name, item2.name, direction);
    case ColumnKeys.STATUS:
      return compareStrings(
        getExchangeAntimalwareItemStatus(
          item1.active ? ExchangeAntimalwareItemStatus.ENABLED : ExchangeAntimalwareItemStatus.DISABLED
        ),
        getExchangeAntimalwareItemStatus(
          item2.active ? ExchangeAntimalwareItemStatus.ENABLED : ExchangeAntimalwareItemStatus.DISABLED
        ),
        direction
      );
    case ColumnKeys.APPLY_TO:
      return compareStrings(getExchangeApplyToRule(item1.applyTo), getExchangeApplyToRule(item2.applyTo), direction);
    case ColumnKeys.SENDERS:
      return compareStrings(getExchangeRuleSenders(item1.senders), getExchangeRuleSenders(item2.senders), direction);
    case ColumnKeys.RECIPIENTS:
      return compareStrings(
        getExchangeRuleSenders(item1.recipients),
        getExchangeRuleSenders(item2.recipients),
        direction
      );
  }

  return 0;
}
